import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Projects.css';

const ArrowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="7" y1="17" x2="17" y2="7"/><polyline points="7 7 17 7 17 17"/>
  </svg>
);

import { usePortfolio } from '../context/PortfolioContext';

const categories = ['All', 'React', 'UI/UX', 'Web Design'];

export default function Projects() {
  const { data, loading } = usePortfolio();

  if (loading || !data) {
    return <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-dark)', color: 'white' }}>Loading...</div>;
  }
  const { projects } = data;
  return (
    <div className="projects-page page-enter">
      <Navbar />

      {/* HEADER */}
      <section className="proj-header">
        <div className="proj-container">
          <span className="proj-badge">Selected Works</span>
          <h1>My <span className="purple">Projects</span></h1>
          <p>A curated collection of my design and development work. Click any card to visit the live project.</p>
        </div>
      </section>

      {/* GRID */}
      <section className="proj-grid-section">
        <div className="proj-container">
          <div className="proj-grid">
            {projects.map(p => (
              <div key={p.id} className="proj-card">
                {/* Thumbnail */}
                <div className="proj-thumb" style={p.image ? undefined : { background: p.gradient }}>
                  {p.image && <img className="proj-thumb-image" src={p.image} alt={`${p.title} preview`} />}
                  <div className="proj-thumb-overlay">
                    {p.link ? (
                      <a
                        href={p.link}
                        target="_blank"
                        rel="noreferrer"
                        className="proj-view-btn"
                      >
                        View Live <ArrowIcon />
                      </a>
                    ) : (
                      <span className="proj-add-link-hint">
                        + Add project link in Projects.jsx
                      </span>
                    )}
                  </div>
                  {/* Decorative illustration */}
                  {!p.image && (
                    <svg
                      className="proj-thumb-icon"
                      width="70" height="70"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke={p.dark ? 'rgba(0,0,0,0.12)' : 'rgba(255,255,255,0.2)'}
                      strokeWidth="1.2"
                      strokeLinecap="round"
                    >
                      <rect x="3" y="3" width="18" height="18" rx="2"/>
                      <path d="M3 9h18M9 21V9"/>
                    </svg>
                  )}
                </div>

                {/* Body */}
                <div className="proj-body">
                  <div className="proj-tags">
                    {p.tags.map(t => <span key={t} className="tag">{t}</span>)}
                  </div>
                  <h3>{p.title}</h3>
                  <p>{p.desc}</p>
                  {p.link ? (
                    <a href={p.link} target="_blank" rel="noreferrer" className="proj-link">
                      Visit Project <ArrowIcon />
                    </a>
                  ) : (
                    <span className="proj-link-placeholder">Add link to activate →</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
